export default {"src":"/_next/static/media/reckitt.2d465fe5.svg","height":121,"width":170,"blurWidth":0,"blurHeight":0};